import { useEffect, useState } from "react";
import AllyService from "../../services/ally.service";
import { CotizacionEntradas } from "../../types/common.types";

// Entradas que cobraría el tour en esa fecha para estos huéspedes, calculadas por el backend con las
// tarifas de la pestaña Parques. Es solo para mostrar: al guardar la reserva el backend vuelve a
// calcular, y ese es el monto que queda.
export default function useEntradas(tour_id?: string, fecha?: Date | string, passenger_ids: string[] = []) {
    const [cotizacion, setCotizacion] = useState<CotizacionEntradas>()
    const [cargando, setCargando] = useState(false)
    const ids = passenger_ids.filter(Boolean).join(',')

    useEffect(() => {
        let vigente = true
        setCotizacion(undefined)
        if (!tour_id || !fecha || !ids) return
        setCargando(true)
        AllyService.cotizarEntradas(tour_id, fecha, ids.split(','))
            .then(res => { if (vigente) setCotizacion(res.data) })
            .catch(() => { if (vigente) setCotizacion(undefined) })
            .finally(() => { if (vigente) setCargando(false) })
        return () => { vigente = false }
    }, [tour_id, fecha instanceof Date ? fecha.getTime() : fecha, ids]) // eslint-disable-line react-hooks/exhaustive-deps

    return { cotizacion, cargando }
}
